export default __webpack_public_path__ + "5e4d5cbdc24ee9f9075f9ff4947a5a51.png";